"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API Key Management API
 * API for managing verifying email addresses on the Socrata platform.  # Signing Up On The Socrata Platform  When a user signs up for the platform, an email containing a token will be sent to the address they signed up with.  New users will not be able to login to the platform or be added as a collaborator on any assets until they first click the link that was emailed to them.  # Changing Emails  When a user wants to change their email address, they can do so if they also provide their current password.  When this is done, an email will be sent to the new email address that contains a token.  An email will also be sent to the user\'s old account letting them know that their email has changed on the platform. This is to protect users whose accounts may have been compromised to let them know of malicious email change attempts. In this case, they can contact Socrata support to reclaim the account if needed.  The email change will be pending and the user will still have their old email address until they click the link that was emailed to their new account. When this link is clicked, the email change is applied.  # Changelog  ## 1.1.0  Change generator enum property naming to `original` for `typescript-fetch` client.  Add missing error codes.  ## 1.0.0  Initial specification.
 *
 * The version of the OpenAPI document: 1.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessResponseEmailResentToJSON = exports.SuccessResponseEmailResentFromJSONTyped = exports.SuccessResponseEmailResentFromJSON = void 0;
function SuccessResponseEmailResentFromJSON(json) {
    return SuccessResponseEmailResentFromJSONTyped(json, false);
}
exports.SuccessResponseEmailResentFromJSON = SuccessResponseEmailResentFromJSON;
function SuccessResponseEmailResentFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SuccessResponseEmailResentFromJSONTyped = SuccessResponseEmailResentFromJSONTyped;
function SuccessResponseEmailResentToJSON(value) {
    return value;
}
exports.SuccessResponseEmailResentToJSON = SuccessResponseEmailResentToJSON;
